import "./LabTestAdd.scss";
import { App, Button, Card, Col, DatePicker, Divider, Form, Input, Row, Select, Space, TimePicker } from "antd";
import Heading from "../../common/Heading/Heading";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { addLabTests, getEmployees, getLabTestsDetails, getLabTestTemplates, getMedicalCodes, getPractitioners } from "../../../network/labTest";
import { queryKeys } from "../../../services/react-query/queryKeys";
import { getPatients } from "../../../network/patients";
import { MdDelete } from "react-icons/md";
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import dayjs from "dayjs";
import { useNavigate, useParams } from "react-router-dom";
import { useState } from "react";
const LabTestAdd = ({t,edit}) => {
  const client = useQueryClient();
  const {id} = useParams();
  const { message } = App.useApp();
    const [form] = Form.useForm();
    const [loadingAdd, setLoadingAdd] = useState(false);
    const navigate = useNavigate();
                const { mutate: onAddLabTests } = useMutation({
                  mutationKey: ['addLabTests'],
                  mutationFn: (body) =>
                    edit ? addLabTests(body) : addLabTests(body),
                  onSuccess: (data) => {
                    setLoadingAdd(false);
                    // console.log(data?.message, 'datawwww');
                    if (data?.message?.status === 500) {
                      message.error(data?.message?.message);
                      return false;
                    }
                    message.success(data?.message?.message);
                    client.invalidateQueries({
                      queryKey: [queryKeys.getLabTestsList],
                    });
                    form.resetFields();
                    navigate('/lab-test');
                  },
                  onError: (error) => {
                    setLoadingAdd(false);
                    console.log('error:', error);
                    // message.error(error);
                  },
                });
    const { data: labTestTemplates } = useQuery({
      queryKey: [queryKeys.getLabTestTemplates],
      queryFn: () => getLabTestTemplates(),
      keepPreviousData: true,
    });
      const { data: patients } = useQuery({
        queryKey: [queryKeys.patients],
        queryFn: () => getPatients(),
        keepPreviousData: true,
      });
      const { data: practitioners } = useQuery({
        queryKey: [queryKeys.getPractitioners],
        queryFn: () => getPractitioners(),
        keepPreviousData: true,
      });
      const { data: employees } = useQuery({
        queryKey: [queryKeys.getEmployees],
        queryFn: () => getEmployees(),
        keepPreviousData: true,
      });
      const { data: medicalCodes } = useQuery({
        queryKey: [queryKeys.getMedicalCodes],
        queryFn: () => getMedicalCodes(),
        keepPreviousData: true,
      });
      // const { data: labTestDetails } = useQuery({
      //   queryKey: [queryKeys.getLabTestsDetails, id],
      //   queryFn: () => getLabTestsDetails(id),
      //   keepPreviousData: true,
      //   enabled: !!edit
      // });
      // console.log(labTestDetails, 'labTestDetails');
    const onFinish = (values) => {
        console.log('Finish:', values);
        setLoadingAdd(true);
        onAddLabTests({
          labtestData: JSON.stringify({
            ...values,
            date: values?.date?.format('YYYY-MM-DD'),
            time: values?.time?.format('HH:mm:ss'),

          }),
        });
    };
    const handleTestTemplate = (value, option) => {
        console.log(value, option);
        form.setFieldsValue({
          department: option?.data?.department,
        });
    }
    const handlePatientFileNumber = (value, option) => {
        console.log(value, option);
        form.setFieldsValue({
          patient: option?.data?.name,
          patient_sex: option?.data?.sex,
          patient_age: option?.data?.age,
          date: dayjs(option?.data?.dob),
        });
    }
    const handleMedicalCode = (value, option) => {
        console.log(value, option);
        form.setFieldsValue({
          items:[
            {
              medical_code_standard: option?.data?.medical_code_standard,
              code: option?.data?.code,
              description: option?.data?.description,
            }
          ]
        });
    }
  return (
    <div className="lab-test-add">
      <Heading title={t.labTest} subTitle={ edit ? t.editLabTest : t.addLabTest} path="/lab-test" />
      <Card>
        <h4 className="title-card">{t.eNTERLABTESTINFORMATION}</h4>
        <Form
          layout="vertical"
          name="nest-messages"
          onFinish={onFinish}
          form={form}
          initialValues={{
            items: [{}],
          }}
        >
          <Divider orientation="left">{t.labTestInformation}</Divider>
          <Row gutter={[16, 0]}>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="template"
                label={t.testTemplate}
                rules={[
                  {
                    required: true,
                    message: t.requiredTestTemplate,
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder={t.testTemplate}
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label ?? '')
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  onChange={(value, option) =>
                    handleTestTemplate(value, option)
                  }
                  options={labTestTemplates?.message?.labtest_templates?.map(
                    (item) => ({
                      label: item.name,
                      value: item.lab_test_name,
                      data: item,
                    })
                  )}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="department"
                label={t.department}
                rules={[
                  {
                    required: true,
                    message: t.requestingDepartment,
                  },
                ]}
              >
                <Input placeholder={t.department} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="custom_file_number"
                label={t.patientFileNumber}
                rules={[
                  {
                    required: true,
                    message: t.requiredPatientFileNumber,
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder={t.patientFileNumber}
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label ?? '')
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  onChange={(value, option) =>
                    handlePatientFileNumber(value, option)
                  }
                  options={patients?.message?.message?.map((item) => ({
                    label: item.custom_file_number,
                    value: item.name,
                    data: item,
                  }))}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="patient"
                label={t.patientName}
                rules={[
                  {
                    required: true,
                    message: t.requiredPatientName,
                  },
                ]}
              >
                <Input placeholder={t.patientName} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="patient_sex"
                label={t.gender}
                rules={[
                  {
                    required: true,
                    message: t.requiredGender,
                  },
                ]}
              >
                <Select
                  placeholder={t.gender}
                  options={[
                    {
                      value: 'Male',
                      label: t.male,
                    },
                    {
                      value: 'Female',
                      label: t.female,
                    },
                  ]}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="patient_age"
                label={t.patientAge}
                rules={[
                  {
                    required: true,
                    message: t.requiredPatientAge,
                  },
                ]}
              >
                <Input placeholder={t.patientAge} type="number" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="date"
                label={t.date}
                // initialValue={dayjs()}
                rules={[
                  {
                    required: true,
                    message: t.requiredDate,
                  },
                ]}
              >
                <DatePicker
                  placeholder={t.date}
                  format="YYYY-MM-DD"
                  style={{ width: '100%' }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="time"
                label={t.time}
                // initialValue={dayjs()}
                // rules={[
                //   {
                //     required: true,
                //     message: t.requiredTime,
                //   },
                // ]}
              >
                <TimePicker
                  placeholder={t.time}
                  format="HH:mm"
                  style={{ width: '100%' }}
                  defaultValue={dayjs()}
                  // use12Hours
                  // inputReadOnly
                  // allowClear={false}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="practitioner"
                label={t.patientFileNumber}
                rules={[
                  {
                    required: true,
                    message: t.requiredPatientFileNumber,
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder={t.patientFileNumber}
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label ?? '')
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={practitioners?.message?.message?.map((item) => ({
                    label: item.practitioner_name,
                    value: item.name,
                    data: item,
                  }))}
                  onChange={(value, option) => {
                    console.log(value, option);
                    form.setFieldsValue({
                      requesting_department: option?.data?.department,
                    });
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="requesting_department"
                label={t.requestingDepartment}
                rules={[
                  {
                    required: true,
                    message: t.requiredPatientAge,
                  },
                ]}
              >
                <Input placeholder={t.requestingDepartment} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="employee"
                label={t.employeeLab}
                // rules={[
                //   {
                //     required: true,
                //     message: t.requiredEmployeeLab,
                //   },
                // ]}
              >
                <Select
                  showSearch
                  placeholder={t.employeeLab}
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label ?? '')
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={employees?.message?.employees?.map((item) => ({
                    label: item.employee_name,
                    value: item.name,
                  }))}
                />
              </Form.Item>
            </Col>
            <Divider orientation="left">{t.comment}</Divider>
            <Col span={24}>
              <Form.Item name="lab_test_comment" label={t.comment}>
                <Input.TextArea
                  placeholder={t.comment}
                  autoSize={{ minRows: 6, maxRows: 7 }}
                />
              </Form.Item>
            </Col>
            <Divider orientation="left">{t.medicalCoding}</Divider>
            <Col span={24} className="items">
              <Form.List name="items" style={{ width: '100%' }}>
                {(fields, { add, remove }) => (
                  <>
                    {fields?.map(({ key, name, ...restField }) => (
                      <Space
                        key={key}
                        style={{
                          display: 'flex',
                          //   marginBottom: 8,
                          //   justifyContent: 'space-between',
                          alignItems: 'center',
                          width: '100%',
                        }}
                        // align="baseline"
                      >
                        <Form.Item
                          name={[name, 'medical_code']}
                          label={t.medicalCode}
                          style={{ width: '100%', marginBottom: '0px' }}
                          {...restField}
                        >
                          <Select
                            placeholder={t.medicalCode}
                            style={{ width: '100%' }}
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              (option?.label ?? '')
                                .toLocaleLowerCase()
                                .includes(input)
                            }
                            filterSort={(optionA, optionB) =>
                              (optionA?.label ?? '')
                                .toLowerCase()
                                .localeCompare(
                                  (optionB?.label ?? '').toLowerCase()
                                )
                            }
                            onChange={(value, option) => {
                              handleMedicalCode(value, option);
                            }}
                            options={medicalCodes?.message?.medical_codes?.map(
                              (country) => ({
                                value: country.name,
                                label: country.name,
                                data: country,
                              })
                            )}
                          />
                        </Form.Item>
                        <Form.Item
                          name={[name, 'medical_code_standard']}
                          style={{ width: '100%', marginBottom: '0px' }}
                          {...restField}
                          label={t.medicalCodeStandard}
                        >
                          <Input
                            placeholder={t.medicalCodeStandard}
                            style={{ width: '100%' }}
                          />
                        </Form.Item>
                        <Form.Item
                          name={[name, 'code']}
                          style={{ width: '100%', marginBottom: '0px' }}
                          {...restField}
                          label={t.code}
                        >
                          <Input
                            placeholder={t.code}
                            style={{ width: '100%' }}
                          />
                        </Form.Item>
                        <Form.Item
                          name={[name, 'description']}
                          style={{ width: '100%', marginBottom: '0px' }}
                          {...restField}
                          label={t.description}
                        >
                          <Input
                            placeholder={t.description}
                            style={{ width: '100%' }}
                          />
                        </Form.Item>
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            fontSize: '15px',
                            margin: '0 10px',
                          }}
                        >
                          {fields.length > 1 && (
                            <Button
                              type="text"
                              onClick={() => remove(name)}
                              danger
                              icon={<MdDelete color="red" />}
                            />
                          )}
                          <Button
                            type="text"
                            onClick={() => add()}
                            icon={<PlusOutlined color="#1890ff" />}
                          />
                        </div>
                      </Space>
                    ))}
                  </>
                )}
              </Form.List>
            </Col>
            <Divider orientation="left">{t.worksheetPrint}</Divider>
            <Col span={24}>
              <Form.Item
                name="worksheet_instructions"
                label={t.worksheetPrint}
                // rules={[
                //   {
                //     required: true,
                //     message: t.requiredEmployeeLab,
                //   },
                // ]}
              >
                <Input.TextArea
                  placeholder={t.worksheetPrint}
                  autoSize={{ minRows: 6, maxRows: 7 }}
                />
              </Form.Item>
            </Col>
            <Divider orientation="left">{t.resultLegendPrint}</Divider>
            <Col xs={24} sm={24} md={8} lg={8}>
              <Form.Item
                name="legend_print_position"
                label={t.printPosition}
                // rules={[
                //   {
                //     required: true,
                //     message: t.requiredEmployeeLab,
                //   },
                // ]}
              >
                <Input placeholder={t.printPosition} />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item name="result_legend" label={t.resultLegend}>
                <Input.TextArea
                  placeholder={t.resultLegend}
                  autoSize={{ minRows: 6, maxRows: 7 }}
                />
              </Form.Item>
            </Col>
          </Row>
          <div className="form-btns">
            <Button
              type="primary"
              ghost
              onClick={() => navigate('/practitioners')}
            >
              {t.Cancel}
            </Button>
            <Button type="primary" htmlType="submit" loading={loadingAdd}>
              {edit ? t.edit : t.submit}
            </Button>
          </div>
        </Form>
      </Card>
    </div>
  );
}

export default LabTestAdd